<template>
  <div class="container">
    <div id="chart-pie" ref="chartPie" class="chart"></div>
    <div class="tips">
      <div>
        <div class="icon" :style="{'background-color': '#eb0000'}"></div>
        <div class="tip-content">
          <span>买盘</span>
          {{tips.U | formatUnit}}手
        </div>
      </div>
      <div>
        <div class="icon" :style="{'background-color': '#1BAA3C'}"></div>
        <div class="tip-content">
          <span>卖盘</span>
          {{tips.D | formatUnit}}手
        </div>
      </div>
      <div>
        <div class="icon" :style="{'background-color': '#666'}"></div>
        <div class="tip-content">
          <span>中性盘</span>
          {{tips.N | formatUnit}}手
        </div>
      </div>
      <p class="note">注:单笔交易额 >100万</p>
    </div>
    <div class="ticks">
      <p
        class="tick"
        :class="getColor(item.kind)"
        v-for="(item,index) in list"
        :key="index"
        >
        <span class="time">{{item.showTime}}</span>
        <span class="price">{{item.price}}</span>
        <span class="volume" :class="{'tiny-font': item.volue > 10000}">{{item.volume | formatUnit}}</span>
      </p>
    </div>
  </div>
</template>

<script>
import {getBillData} from '@/api'
import {formatUnit} from '@/utils'

import { mapState } from 'vuex'
import echarts from 'echarts'

export default {
  data() {
    return {
      list: [],
      tips: {}
    }
  },
  computed: {
    ...mapState(['market', 'code'])
  },
  filters: {
    formatUnit(val) {
      return formatUnit(val, false, true, 0)
    }
  },
  async created() {
    const res = await getBillData({
      market: this.market,
      code: this.code
    })
    if (res.result.data) {
      this.list = res.result.data.filter(item => {
          return item.price * item.volume > 1000000
        }).sort((v1, v2) => {
          if (v1.ticktime < v2.ticktime) return -1
          if (v1.ticktime > v2.ticktime) return 1
          return 0
        }).reverse() || []
      this.list.forEach(item => {
        item.showTime = item.ticktime.substring(0, 5)
        item.price = item.price.substring(0, item.price.length - 1)
        item.volume = item.volume ? Math.ceil(item.volume / 100) : 0
      })
      this.handleData()
    }
  },
  mounted() {
    this.chart = echarts.init(this.$refs.chartPie)
  },
  methods: {
    handleData() {
      let tips = {D:0, U: 0, N: 0}
      this.list.forEach(v1 => {
        switch (v1.kind) {
          case 'D':
          case 'U':
            tips[v1.kind] += +v1.volume
            break;
          default:
            tips['N'] += +v1.volume
            break;
        }
      })
      this.tips = tips
      this.renderChart(tips)
    },
    renderChart(opts) {
      let sum = opts.D + opts.U + opts.N
      let NP = Number((opts['N']/sum * 100).toFixed(1))
      let DP = Number((opts['D']/sum * 100).toFixed(1))
      let UP = Number((100 - NP - DP).toFixed(1))
      let option = {
        animation: false,
        series : [
          {
            type: 'pie',
            radius : '100%',
            center: ['50%', '50%'],
            labelLine: {
              show: false,
            },
            label: {
              show: true,
              color: '#fff',
              position: 'inside'
            },
            data:[]
          }
        ]
      }
      if (opts['D'] > 0) option.series[0].data.push({value:opts['D'], name: DP + '%', itemStyle: {color: '#1BAA3C'}})
      if (opts['U'] > 0) option.series[0].data.push({value:opts['U'], name: UP + '%', itemStyle: {color: '#eb0000'}})
      if (opts['N'] > 0) option.series[0].data.push({value:opts['N'], name: NP + '%', itemStyle: {color: '#666'}})
      this.chart.setOption(option)
    },
    getColor(type) {
      if(type === 'U') return 'rise-color'
      if(type === 'D') return 'fall-color'
    }
  }
}
</script>

<style lang="stylus" scoped>
  .container
    font-size .11rem
  .chart
    height .84rem
    padding-top .06rem
  
  .tips
    margin .05rem 0
    height .9rem
    color #666
    border-bottom 1px solid #EDEFF3
    >div
      display flex
      height .17rem
      align-items center
      margin-bottom .05rem
  
  .tip-content
    display flex
    width .9rem
    justify-content space-between

  .icon
    height .08rem
    width .08rem
    margin 0 .03rem
  
  .note
    font-size .1rem
    color #999
    text-align center
  
  .ticks
    height 1rem
    overflow-y auto
  
  .tick
    display flex
  
  .time
    width .3rem
    color #666 !important

  .price
    width .37rem
    text-align right

  .volume
    width .34rem
    text-align right

  .tiny-font
    font-size .1rem
</style>